import React, { Suspense, lazy } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import AuthRoute from '../components/AuthRoute';
import { ADMIN_PERMISSIONS, SYSTEM_PERMISSION } from '../constants';

const Patient = lazy(() => import('../pages/Patient'));
const OutgoingPrescriptionOrders = lazy(() => import('../pages/OutgoingPrescriptionOrder'));
const Notifications = lazy(() => import('../pages/Notifications'));
const PractiseManager = lazy(() => import('../pages/PractiseAdmin/PractiseManager'));
const IncomingRefillRequests = lazy(() => import('../pages/IncomingRefillRequests'));
const ChangeRequests = lazy(() => import('../pages/ChangeRequests'));
const Profile = lazy(() => import('../pages/Profile'));
const ActivityReports = lazy(() => import('../pages/ActivityReports'));
const SecurityAudit = lazy(() => import('../pages/SecurityAudit'));
const UserManagement = lazy(() => import('../pages/PractiseAdmin/UserManagement'));
const CreateUser = lazy(() => import('../pages/PractiseAdmin/UserManagement/CreateUser'));
const EditUser = lazy(() => import('../pages/PractiseAdmin/UserManagement/EditUser'));
const GroupUsers = lazy(() => import('../pages/PractiseAdmin/GroupManagement/GroupUsers'));
const GroupPermissions = lazy(() => import('../pages/PractiseAdmin/GroupManagement/GroupPermissions'));
const CreateGroup = lazy(() => import('../pages/PractiseAdmin/GroupManagement/CreateGroup'));
const CreateRole = lazy(() => import('../pages/PractiseAdmin/RoleManagement/CreateRole'));
const RoleGroups = lazy(() => import('../pages/PractiseAdmin/RoleManagement/RoleGroups'));
const RoleManagement = lazy(() => import('../pages/PractiseAdmin/RoleManagement'));
const GroupManagement = lazy(() => import('../pages/PractiseAdmin/GroupManagement'));
const Dashboard = lazy(() => import('../pages/Dashboard'));

const Routes = (props) => {
   return (
      <Suspense fallback={<div>Loading...</div>}>
         <Switch>
            <Route exact={false} path="/dashboard" component={Dashboard} />
            <AuthRoute
               exact={false}
               path="/patient"
               permission={SYSTEM_PERMISSION.API_PDM_OP_GET_PATIENT_LIST}
               component={Patient}
            />
            <AuthRoute
               exact={true}
               path="/orders/outgoing-prescription-orders"
               permission={SYSTEM_PERMISSION.API_PCO_GET_RX_ORDER_LIST}
               component={OutgoingPrescriptionOrders}
            />
            <AuthRoute
               exact={true}
               path="/orders/incoming-refill-requests"
               permission={SYSTEM_PERMISSION.API_ERX_REFILL_REQUEST_LIST}
               component={IncomingRefillRequests}
            />
            <AuthRoute
               exact={true}
               path="/orders/change-requests"
               permission={SYSTEM_PERMISSION.API_ERX_CHANGE_REQUEST_LIST}
               component={ChangeRequests}
            />
            <AuthRoute
               exact={true}
               path="/users"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_GET_USER_LIST}
               component={UserManagement}
            />
            <AuthRoute
               exact={true}
               path="/users/newUser"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_CREATE_USER}
               component={CreateUser}
            />
            <AuthRoute
               exact={true}
               path="/users/editUser"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_UPDATE_USER}
               component={EditUser}
            />
            <AuthRoute
               exact={true}
               path="/groups"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_GET_GROUP_LIST}
               component={GroupManagement}
            />
            <AuthRoute
               exact={true}
               path="/groups/newGroup"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_CREATE_GROUP}
               component={CreateGroup}
            />
            <AuthRoute
               exact={true}
               path="/roles"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_GET_ROLE_LIST}
               component={RoleManagement}
            />
            <AuthRoute
               exact={true}
               path="/roles/newRole"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_CREATE_ROLE}
               component={CreateRole}
            />
            <AuthRoute
               exact={true}
               path="/roles/roleGroups"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_GET_ROLE}
               component={RoleGroups}
            />
            <AuthRoute
               exact={true}
               path="/groups/groupUsers"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_GET_USER_IN_GROUP}
               component={GroupUsers}
            />
            <AuthRoute
               exact={true}
               path="/groups/groupPermissions"
               permission={SYSTEM_PERMISSION.API_UGRP_OP_GET_USER_IN_GROUP}
               component={GroupPermissions}
            />
            <Route exact={true} path="/notifications" component={Notifications} />
            <AuthRoute
               exact={true}
               path="/practiceManager"
               permission={ADMIN_PERMISSIONS}
               all
               component={PractiseManager}
            />
            <Route exact={true} path="/profile" component={Profile} />
            <AuthRoute
               exact={true}
               path="/activity-log-reports"
               permission={SYSTEM_PERMISSION.API_UGRP_LOAD_LOGGED_ACTIVITY}
               component={ActivityReports}
            />
            <AuthRoute
               exact={true}
               path="/security-audit-reports"
               permission={ADMIN_PERMISSIONS}
               all
               component={SecurityAudit}
            />
         </Switch>
      </Suspense>
   );
};

const mapStateToProps = ({ authReducer }) => {
   return {
      isLoggedIn: authReducer.isLoggedIn,
   };
};

export default connect(mapStateToProps)(Routes);
